import React, { useState } from 'react'
import { Row, Col, Form, Input, FormGroup, Button, Label, Alert, Modal, ModalHeader, ModalBody, ModalFooter, } from "reactstrap"
import { GroupsTypeAhead, RepsTypeAhead } from "./TypeAheadComponents"
import { CreateBoardMutation } from "../Mutations"
import withApolloClient from '../../withApolloClient'

function NewBoardModal({ isOpen, closeModal, ...props }) {
    const [title, setTitle] = useState("")
    const [slug, setSlug] = useState("")
    const [description, setDescription] = useState("")
    const [repIds, setRepIds] = useState([])
    const [groupIds, setGroupIds] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)


    const createBoard = (e) => {
        e.preventDefault()
        try {
            if (!props.apolloClient) {
                throw new Error("GQL Client not found")
            }
            const { apolloClient } = props
            if (!apolloClient) {
                throw new Error("GQL Client not found")
            }
            if (!title || title.length < 5) {
                setError("Title is required or too short")
                return
            }
            if (!slug) {
                setError("Slug is required")
                return
            }
            setLoading(true)
            const input = {
                title: title,
                slug: slug.trim(),
                description: description,
                sharedWithUserIds: repIds,
                sharedWithGroupIds: groupIds,
            }

            apolloClient.mutate({
                mutation: CreateBoardMutation,
                refetchQueries: ["AllBoards"],
                variables: { input },
            }).then((result) => {
                setLoading(false)
                if (!result) {
                    throw new Error("Error creating board")
                }
                if (result.data && result.data.createBoard && result.data.createBoard.ok) {
                    setError("")
                    closeModal("")
                } else {
                    const errorMessage = result.data && result.data.createBoard && result.data.createBoard.errors &&
                        result.data.createBoard.errors.length > 0 && result.data.createBoard.errors[0].messages.length > 0 ?
                        result.data.createBoard.errors[0].messages[0] : "Error creating board"
                    throw new Error(errorMessage)
                }
            }).catch((error) => {
                setError("Error creating board" + error.toString())
                setLoading(false)
            })
        } catch (error) {
            setError("Error creating board" + error.toString())
            setLoading(false)
        }
    }

    return (
        <Modal isOpen={isOpen} className="">
            <ModalHeader>Create Board</ModalHeader>
            <ModalBody>
                <Form onSubmit={createBoard}>
                    <Row>
                        {error && <Col xs={12}><Alert color="danger">{error}</Alert></Col>}
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="title">Title *</Label>
                                <Input type="string" name="title" id="title" placeholder="Give your board a title" value={title} onChange={(e) => setTitle(e.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="description">Description</Label>
                                <Input type="string" name="description" id="description" placeholder="Add more details" value={description} onChange={(e) => setDescription(e.target.value)} />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="slug">Slug / Custom ID *</Label>
                                <Input
                                    type="string"
                                    name="slug"
                                    id="slug"
                                    placeholder="unique-board-id"
                                    value={slug}
                                    onChange={(e) => setSlug(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="repIds">Share With Groups</Label>
                                <GroupsTypeAhead onChange={(selectedGroupIds) => { setGroupIds(selectedGroupIds) }} />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <FormGroup>
                                <Label for="repIds">Share With Users</Label>
                                <RepsTypeAhead onChange={(selectedRepIds) => { setRepIds(selectedRepIds) }} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                    <ModalFooter>
                        {loading ?
                            <Button color="primary" disabled={true}>Creating Board...</Button> :
                            <Button color="primary" type="submit" disabled={!title || !slug || loading}>Create Board</Button>}
                        <Button color="secondary" onClick={closeModal}>Close</Button>
                    </ModalFooter>
                </Form>
            </ModalBody>
        </Modal>
    )
}

export default (withApolloClient(NewBoardModal))
